export function createPatientRulesForRitualPreventionConfig() {
	return {
		title: "Patient Rules for Ritual Prevention",
		instructions: "Review these ritual-prevention rules with your therapist and use them during the agreed exposure practice.",
		fields: [],
		allowEmptyFields: true,
		handoutConfig: {
			sections: [
				{id: "washing", title: "Washing", rules: [
					{id: "wash_1", text: "During the treatment period, avoid using water on your body for several days. This includes no hand washing, no rinsing, no wet towels, no washcloths."},
					{id: "wash_2", text: "The use of creams and other toiletry articles (powder, deodorant, etc.) is permitted unless you find that use of these items reduces your feeling of contamination and/or distress."},
					{id: "wash_3", text: "Shave using an electric shaver."},
					{id: "wash_4", text: "Water is permitted for drinking and brushing teeth, but take care not to get it on your face and hands."},
					{id: "wash_5", text: "Showers are permitted every 3 days, for 10 minutes each—this includes hair washing. Ritualistic or repetitive washing of specific areas of the body (genitals, hair) during showers is prohibited. Showers should be timed by your designated support person, but you need not be observed directly."},
					{id: "wash_6", text: "While at home, if you have an urge to wash or clean and you are afraid you cannot resist, talk to your designated support person and ask him/her to remain with you until the urge decreases to a manageable level."},
					{id: "wash_7", text: "You should report difficulties with ritual prevention to your therapist."},
				]},
				{id: "checking", title: "Checking", rules: [
					{id: "check_1", text: "Only “normal” checking is permitted for most items (such as one check of door locks) unless otherwise recommended by your therapist."},
					{id: "check_2", text: "For items ordinarily not checked (for example, empty envelopes to be discarded), all checking is prohibited."},
					{id: "check_3", text: "While at home, if you have an urge to check and you are afraid you can’t resist, talk to your designated support person and ask him/her to remain with you until the urge decreases to a manageable level."},
					{id: "check_4", text: "You should report difficulties with ritual prevention to your therapist."},
				]},
			],
			focusOptions: [{id: "washingFocus", title: "Washing", sectionId: "washing"}, {id: "checkingFocus", title: "Checking", sectionId: "checking"}],
			defaultFocusId: "washingFocus",
			context: "",
			specialInstructions: "",
			permittedBehavior: "",
			acknowledgementEnabled: true,
			questionId: "patientQuestions",
			questionText: "What questions do you have about these rules?\nWhich ordinary behaviors would you like to clarify?",
			labels: {
				focus: "Ritual focus", context: "Exposure or homework context", rules: "Ritual-prevention rules", permitted: "Permitted ordinary behavior", special: "Special instructions", acknowledgement: "I have reviewed these rules", acknowledged: "Yes", notAcknowledged: "Not yet", questions: "Questions for your therapist", noQuestions: "No questions recorded.", readiness: "Handout status", ready: "Ready", draft: "Draft", missing: "Complete before sharing", notes: "Practitioner review notes", markReady: "Mark ready", returnDraft: "Return to draft", printPatientCopy: "Print patient copy",
			},
		},
	}
}

export function createPatientRulesForRitualPreventionDemoPayload() {
	return {selectedFocusId: "washingFocus", acknowledged: false, answers: {patientQuestions: "Can we clarify what counts as rinsing after cooking?"}}
}

export function createPatientRulesForRitualPreventionDemoConfig() {
	const config = createPatientRulesForRitualPreventionConfig()
	config.handoutConfig.context = "Kitchen cleanup after dinner"
	return config
}
